import { GoogleAuthProvider, reauthenticateWithPopup } from "firebase/auth";
import { auth } from "@/firebase/app";

export const GOOGLE_SHEETS_READONLY_SCOPE = "https://www.googleapis.com/auth/spreadsheets.readonly";

export async function getGoogleSheetsAccessToken(): Promise<string> {
  const user = auth.currentUser;
  if (!user) throw new Error("Sign in with Google before connecting a private spreadsheet.");
  if (!user.providerData.some((provider) => provider.providerId === "google.com")) {
    throw new Error("Sign in with Google before connecting a private spreadsheet.");
  }

  const provider = new GoogleAuthProvider();
  provider.addScope(GOOGLE_SHEETS_READONLY_SCOPE);
  const result = await reauthenticateWithPopup(user, provider);
  const credential = GoogleAuthProvider.credentialFromResult(result);
  const token = credential?.accessToken;
  if (!token) throw new Error("Google did not return a Sheets access token.");
  return token;
}
